import { Type } from "src/utils";

/**
 * 表示一个访问枚举。
 * @enum
 * @version 1.0.0
 */
enum VisType
{
    /**
     * 登陆
     * @member
     */
    LOGIN = 0,

    /**
     * 登出
     * @member
     */
    LOGOUT = 1,

    /**
     * 注册 
     * @member
     */
    REGISTER = 2,

    /**
     * 改密 
     * @member
     */
    CHANGEPASSWORD = 3,

    /**
     * 三方授权登陆 
     * @member
     */
    AUTHORIZEDLOGIN  = 4,
}

/*
* 定义枚举元数据。
*/
Type.setMetadata(VisType,
{
    LOGIN:
    {
        alias: "登录",
        description: ""
    },
    LOGOUT:
    {
        alias: "登出",
        description: ""
    },
    REGISTER:
    {
        alias: "注册",
        description: ""
    },
    CHANGEPASSWORD:
    {
        alias: "改密",
        description: ""
    },
    AUTHORIZEDLOGIN:
    {
        alias: "三方授权登陆",
        description: ""
    }
});

export default VisType;